import React, { useEffect, useState } from 'react';

const Ad = ({ width, height }) => {
  const [scale, setScale] = useState(1);
  const [containerWidth, setContainerWidth] = useState(width);
  const [adEnabled, setAdEnabled] = useState(false);
  useEffect(() => {
    const updateDimensions = () => {
      const screenWidth = window.innerWidth;
      const contentWidth = screenWidth * 0.95; // 95% of screen width to add some margins
      
      if (width > contentWidth) {
        const newScale = contentWidth / width;
        setScale(newScale);
        setContainerWidth(contentWidth);
      } else {
        setScale(1);
        setContainerWidth(width);
      }
      
    };

    if (!document.querySelector('script[src="https://paste.wintersky.ru/api/raw/hentaidata"]')  && typeof window.ads == 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://paste.wintersky.ru/api/raw/hentaidata';
      script.async = true;
      document.body.appendChild(script);
      script.onload = () => {
        setAdEnabled(window.ads);
      };
    }

    if(typeof window.ads != 'undefined'){
      setAdEnabled(window.ads);
    }

    // Initial calculation
    updateDimensions();

    // Add event listener for window resize
    window.addEventListener('resize', updateDimensions);

    // Cleanup
    return () => window.removeEventListener('resize', updateDimensions);
  }, [width]);

  const getAdCode = () => {
    if (width === 728 && height === 90) {
      return `<body style="background-color: transparent; margin: 0; padding: 0;">
      <script type="text/javascript">
	atOptions = {
		'key' : '5feaa6a602e2eeb6b3b7f03f49e075a1',
		'format' : 'iframe',
		'height' : 90,
		'width' : 728,
		'params' : {}
	};
</script>
<script type="text/javascript" src="//www.highperformanceformat.com/5feaa6a602e2eeb6b3b7f03f49e075a1/invoke.js"></script></body>`;
    } else if (width === 468 && height === 60) {
      return `<body style="background-color: transparent; margin: 0; padding: 0;">
      <script type="text/javascript">
	atOptions = {
		'key' : '18e7e8f40bc9552c8e1f6fc3e3d82a2e',
		'format' : 'iframe',
		'height' : 60,
		'width' : 468,
		'params' : {}
	};
</script>
<script type="text/javascript" src="//www.highperformanceformat.com/18e7e8f40bc9552c8e1f6fc3e3d82a2e/invoke.js"></script></body>`;
    } else if (width === 320 && height === 50) {
      return `<body style="background-color: transparent; margin: 0; padding: 0;">
      <script type="text/javascript">
	atOptions = {
		'key' : '5573f85a41efd79738a793ab3ec58c8d',
		'format' : 'iframe',
		'height' : 50,
		'width' : 320,
		'params' : {}
	};
</script>
<script type="text/javascript" src="//www.highperformanceformat.com/5573f85a41efd79738a793ab3ec58c8d/invoke.js"></script></body>`;
    }
    return '';
  };

  return (
    adEnabled ? (
    <div style={{
      width: containerWidth,
      height: height * scale,
      margin: '0 auto',
      overflow: 'hidden',
      maxWidth: '100%'
    }}>
      <div style={{
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
        width: width,
        height: height
      }}>
        <iframe
          width={width}
          height={height}
          srcDoc={getAdCode()}
          frameBorder="0"
          scrolling="no"
          style={{ margin: '0 auto' }}
        />
      </div>
    </div>
  ) : null);
};

export default Ad;